import React, { useEffect } from "react";
import MemberPartnerDashboard from "./MemberPartnerDashboard";
import {
  Alert,
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../../../styles/pages/user/memberpartner/memberpartner-account.module.scss";

import EditIcon from "../../../ui/Icons/EditIcon";
import { Link } from "react-router-dom";
import userImage from "../../../public/assets/images/user_upload_img.png";
import { useRef } from "react";
import { useState } from "react";
import AlertIcon from "../../../ui/Icons/Alert";
import PerfectScrollbar from "react-perfect-scrollbar";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import tipati_logo from "../../../public/assets/images/tipati_logo.svg";
import LogoutIcon from "../../../public/assets/icons/LogoutIcon";
import LogIcons from "../../../public/assets/icons/LoginIcons";
import NOprofileImage from "../../../public/assets/images/no-profile-picture-Just.png";
import { StylesProvider } from "@material-ui/core";
import MessageIcon from "../../../ui/Icons/MessageIcon";
import MessageIcons from "../../../ui/Icons/MessageIcons";
import { useMutation } from "react-query";
import { ProfileUpdateMutation } from "../../../api/functions/user.api";
import {
  countryData,
  getAbsoluteImageURI,
} from "../../../lib/functions/utils.lib";
import useFetch from "../../../hooks/api/useFetch";
import TabBackIcon from "../../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../../ui/Icons/TabSaveIcon";
import axiosInstance from "../../../api/axiosInstance";
import useNotiStack from "../../../hooks/useNotistack";
import { parseCookies } from "nookies";
import { Avatar } from "antd";
import ApiLoader from "../../../components/Loaders/ApiLoader";

const SelectItem = [
  {
    name: "Select country",
  },
  {
    name: "Option1",
  },
  {
    name: "Option2",
  },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function MemberPartnerAccount() {
  const [value, setValue] = React.useState(0);
  const { toastSuccess, toastError } = useNotiStack();
  const [dis, setDis] = useState(true);
  const [dis1, setDis1] = useState(true);
  const [dis2, setDis2] = useState(true);
  const [dis3, setDis3] = useState(true);
  const [dis4, setDis4] = useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handelOpen = () => {
    setDis(false);
  };
  const handelClose = () => {
    setDis(true);
  };
  const handelUpdate = () => {
    setDis(true);
    handleSubmit();
  };
  const handelOpen1 = () => {
    setDis1(false);
  };
  const handelClose1 = () => {
    setDis1(true);
  };
  const handelUpdate1 = () => {
    setDis1(true);
    handleSubmit();
  };
  const handelOpen2 = () => {
    setDis2(false);
  };
  const handelClose2 = () => {
    setDis2(true);
  };

  const handelUpdate2 = () => {
    setDis2(true);
    handleSubmit();
  };
  const handelOpen3 = () => {
    setDis3(false);
  };
  const handelClose3 = () => {
    setDis3(true);
  };

  const handelUpdate3 = () => {
    setDis3(true);
    handleSubmit();
  };
  // user data load

  // update account
  const handelOpen4 = () => {
    setDis4(false);
  };
  const handelClose4 = () => {
    setDis4(true);
  };

  const handelUpdate4 = () => {
    setDis4(true);
    handleSubmit();
  };
  // update account
  const {
    data: partnerData,
    isLoading: partnerIsLoading,
    isSuccess: partnerIsSuccess,
    refetch: partnerRefetch,
  } = useFetch(["partnerUser"], `/user`);
  console.warn(
    "🚀 ~ file: UserCreateTab.jsx:368 ~ UserCreateTab ~ partnerDatatotalData:",
    partnerData?.data
  );
  // user data load

  const [age, setAge] = React.useState("0");
  const [country, setCountry] = useState("0");

  console.warn("country", country);

  const handleChange2 = (event) => {
    setCountry(event.target.value);
  };
  const fileInput = useRef(null);
  const cookies = parseCookies();
  const userData = JSON?.parse(cookies?.userdetails || "{}");

  const handleClick = () => {
    fileInput.current.children[0].children[0].click();
  };

  const [profileImage, setProfileImage] = useState(null);
  const [profileImg, setProfileImg] = useState(partnerData?.data?.avatar);
  const [file, setFile] = useState(userImage);

  // const fileChange = (e) => {

  //   setFile(URL.createObjectURL(e.target.files[0]));
  // };
  const handleChanges = (e) => {
    setFile(userImage);
  };
  const removeprofileImage = () => {
    setProfileImage(null);
    setProfileImg(null);
  };

  const { mutateAsync: ProfileUpdateMutationAA } = useMutation({
    mutationFn: ProfileUpdateMutation,
  });

  const handleProfileImage = (e) => {
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 3000000) {
        setProfileImage(e.target.files[0]);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  };

  // formData Handle
  const [formData, setFormData] = useState({
    user_id: userData?.id,
    removeProfile: "true",
    ...partnerData?.data,
  });

  const getFormInputValue = (name) => {
    return formData[name] ? formData[name] : "";
  };
  console.warn("value", getFormInputValue("zip_code"));

  const handleFormData = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  // formData Handle
  const [loginaccess, updateloginaccess] = useState(false);

  const handleloginsubmit = () => {
    updateloginaccess(!loginaccess);
  };

  const handleSubmit = async () => {
    if (!formData) return;
    const managerForm = new FormData();
    {
      profileImage === null ? "" : managerForm.append("avatar", profileImage);
    }

    managerForm.append("user_id", formData?.user_id);
    if (formData?.name !== partnerData?.data?.name) {
      managerForm.append("name", formData?.name);
    }
    if (formData?.last_name !== partnerData?.data?.last_name) {
      managerForm.append("last_name", formData?.last_name);
    }
    if (formData?.address !== partnerData?.data?.address) {
      managerForm.append("address", formData?.address);
    }
    if (formData?.city !== partnerData?.data?.city) {
      managerForm.append("city", formData?.city);
    }
    if (formData?.state !== partnerData?.data?.state) {
      managerForm.append("state", formData?.state);
    }
    if (formData?.zip_code !== partnerData?.data?.zip_code) {
      managerForm.append("zip_code", formData?.zip_code);
    }
    if (country !== partnerData?.data?.country) {
      managerForm.append("country", country);
    }
    if (formData?.phone !== partnerData?.data?.phone) {
      managerForm.append("phone", formData?.phone);
    }
    /* if (profileImage !== null) {
      managerForm.append("avatar", profileImage);
    } */
    if (formData?.account_name !== partnerData?.data?.account_name) {
      managerForm.append("account_name", formData?.account_name);
    }

    if (profileImage) {
      ProfileUpdateMutationAA(managerForm).then((response) => {
        if (response) {
          toastSuccess("User updated successfully");
          console.warn("User updated successfully", response);
          // router.reload();
          partnerRefetch();
          // queryClient.invalidateQueries(["admin", userData?.id]);
        }
      });
    }

    await axiosInstance
      .post("/updateuser", managerForm)
      .then((response) => {
        console.warn(response?.data);
        toastSuccess("User updated successfully");
        partnerRefetch();
        setFormData({
          user_id: userData?.id,
          ...partnerData?.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const changePassword = async () => {
    if (!formData) return;
    const managerForm = new FormData();
    managerForm.append("user_id", formData?.user_id);
    if (formData?.old_password) {
      managerForm.append("old_password", formData?.old_password);
    }
    if (formData?.password) {
      managerForm.append("password", formData?.password);
    }
    if (formData?.confirm_password) {
      managerForm.append("password_confirmation", formData?.confirm_password);
    }

    await axiosInstance
      .post("/user/change-password", managerForm)
      .then((response) => {
        console.warn(response?.data);
        partnerRefetch();
        setFormData({
          user_id: userData?.id,
          ...partnerData?.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    setFormData((prev) => {
      return { ...prev, ...partnerData?.data };
    });
    setCountry(partnerData?.data?.country ? partnerData?.data?.country : "");
  }, [partnerData?.data]);

  return (
    <MemberPartnerDashboardWrapper chatbtn>
      <ApiLoader loading={partnerIsLoading} />
      {partnerIsLoading ? (
        ""
      ) : (
        <Box className={styles.account_settings_wrapper}>
          <Box className={styles.accountsecrp_outer}>
            <Box className={styles.accountsecrp_top}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Personal Details" {...a11yProps(0)} />
                <Tab label="Account Settings" {...a11yProps(1)} />
              </Tabs>
            </Box>

            <Box className={styles.customaccount_wrappers}>
              <Box className={styles.customaccount_wrappers_lf}>
                <Box className={styles.accountsecrp_btms}>
                  <PerfectScrollbar className={styles.custom_account_scroller}>
                    <CustomTabPanel value={value} index={0}>
                      <>
                        <Box className={styles.accountsecrp_btms_inputwrp}>
                          <Box className={styles.heaing_info_label}>
                            <Typography variant="h4">
                              Full name
                              {dis ? (
                                <Link
                                  to=""
                                  className={styles.wdit_spn}
                                  onClick={handelOpen}
                                >
                                  {" "}
                                  <EditIcon />{" "}
                                </Link>
                              ) : (
                                <span>
                                  <Link
                                    to=""
                                    onClick={handelClose}
                                    className={styles.wdit_spn}
                                  >
                                    {" "}
                                    <TabBackIcon />
                                  </Link>
                                  <Link
                                    to=""
                                    className={styles.wdit_spn}
                                    onClick={handelUpdate}
                                  >
                                    {" "}
                                    <TabSaveIcon />
                                  </Link>
                                </span>
                              )}
                            </Typography>
                          </Box>

                          <Box className={styles.inputlabel_wrapper_details}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.7 }}
                            >
                              <Grid item lg={3.08} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    First Name
                                  </Typography>
                                  <TextField
                                    disabled={dis}
                                    // defaultValue="minData"
                                    name="name"
                                    onChange={handleFormData}
                                    value={getFormInputValue("name")}
                                  />
                                </Box>
                              </Grid>

                              <Grid item lg={3.08} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    Last name
                                  </Typography>
                                  <TextField
                                    disabled={dis}
                                    name="last_name"
                                    onChange={handleFormData}
                                    value={getFormInputValue("last_name")}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>

                        <Box className={styles.accountsecrp_btms_inputwrp}>
                          <Box className={styles.heaing_info_label}>
                            <Typography variant="h4">
                              Physical Address
                              {dis1 ? (
                                <Link
                                  to=""
                                  className={styles.wdit_spn}
                                  onClick={handelOpen1}
                                >
                                  {" "}
                                  <EditIcon />{" "}
                                </Link>
                              ) : (
                                <span>
                                  <Link
                                    to=""
                                    onClick={handelClose1}
                                    className={styles.wdit_spn}
                                  >
                                    {" "}
                                    <TabBackIcon />
                                  </Link>
                                  <Link
                                    to=""
                                    className={styles.wdit_spn}
                                    onClick={handelUpdate1}
                                  >
                                    {" "}
                                    <TabSaveIcon />
                                  </Link>
                                </span>
                              )}
                            </Typography>
                          </Box>

                          <Box className={styles.inputlabel_wrapper_details}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.8 }}
                            >
                              <Grid item lg={3.66} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    Address
                                  </Typography>
                                  <TextField
                                    name="address"
                                    disabled={dis1}
                                    onChange={handleFormData}
                                    value={getFormInputValue("address")}
                                  />
                                </Box>
                              </Grid>

                              <Grid item lg={2.6} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    City
                                  </Typography>
                                  <TextField
                                    disabled={dis1}
                                    name="city"
                                    onChange={handleFormData}
                                    value={getFormInputValue("city")}
                                  />
                                </Box>
                              </Grid>

                              <Grid item lg={2.61} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    State
                                  </Typography>
                                  <TextField
                                    disabled={dis1}
                                    name="state"
                                    onChange={handleFormData}
                                    value={getFormInputValue("state")}
                                  />
                                </Box>
                              </Grid>

                              <Grid item lg={1.79} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    Zip Code
                                  </Typography>
                                  <TextField
                                    disabled={dis1}
                                    name="zip_code"
                                    onChange={handleFormData}
                                    value={getFormInputValue("zip_code")}
                                  />
                                </Box>
                              </Grid>

                              <Grid
                                item
                                lg={3.08}
                                xs={12}
                                className={styles.country_sec}
                              >
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={styles.heading_label}
                                  >
                                    Country
                                  </Typography>
                                  <Box
                                    className={styles.namedetails_input_select}
                                  >
                                    <Select
                                      value={country}
                                      onChange={handleChange2}
                                      disabled={dis1}
                                    >
                                      {/* {userData?.country !== "" ? (
                                        <MenuItem value="">
                                          {userData?.country}
                                        </MenuItem>
                                      ) : (
                                        
                                      )} */}
                                      <MenuItem defaultValue={country} value="">
                                        Please Select Country
                                      </MenuItem>
                                      {countryData.map((item, index) => (
                                        <MenuItem
                                          key={index}
                                          value={`${item?.name} (${item?.code})`}
                                        >{`${item?.name} (${item?.code})`}</MenuItem>
                                      ))}
                                    </Select>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>

                        <Box className={styles.accountsecrp_btms_inputwrp}>
                          <Box className={styles.heaing_info_label}>
                            <Typography variant="h4">
                              Phone Number
                              {dis2 ? (
                                <Link
                                  to=""
                                  className={styles.wdit_spn}
                                  onClick={handelOpen2}
                                >
                                  {" "}
                                  <EditIcon />{" "}
                                </Link>
                              ) : (
                                <span>
                                  <Link
                                    to=""
                                    onClick={handelClose2}
                                    className={styles.wdit_spn}
                                  >
                                    {" "}
                                    <TabBackIcon />
                                  </Link>
                                  <Link
                                    to=""
                                    className={styles.wdit_spn}
                                    onClick={handelUpdate2}
                                  >
                                    {" "}
                                    <TabSaveIcon />
                                  </Link>
                                </span>
                              )}
                            </Typography>
                          </Box>

                          <Box className={styles.inputlabel_wrapper_details}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                            >
                              <Grid item lg={3.06} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <TextField
                                    name="phone"
                                    disabled={dis2}
                                    onChange={handleFormData}
                                    value={getFormInputValue("phone")}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>

                        <Box className={styles.accountsecrp_btms_inputwrp}>
                          <Box className={styles.heaing_info_label}>
                            <Typography variant="h4">
                              Salary
                              {dis3 ? (
                                <Link
                                  to=""
                                  className={styles.wdit_spn}
                                  onClick={handelOpen3}
                                >
                                  {" "}
                                  <EditIcon />{" "}
                                </Link>
                              ) : (
                                <span>
                                  <Link
                                    to=""
                                    onClick={handelClose3}
                                    className={styles.wdit_spn}
                                  >
                                    {" "}
                                    <TabBackIcon />
                                  </Link>
                                  <Link
                                    to=""
                                    className={styles.wdit_spn}
                                    onClick={handelUpdate3}
                                  >
                                    {" "}
                                    <TabSaveIcon />
                                  </Link>
                                </span>
                              )}
                            </Typography>
                          </Box>

                          <Box className={styles.inputlabel_wrapper_details}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                            >
                              <Grid item lg={3.06} xs={12}>
                                <Box
                                  className={`${styles.namedetails_input} ${styles.namedtls_captions}`}
                                >
                                  <TextField
                                    name="salary"
                                    disabled={dis3}
                                    onChange={handleFormData}
                                    value={getFormInputValue("salary")}
                                    InputProps={{
                                      startAdornment: (
                                        <>
                                          <Typography
                                            variant="caption"
                                            className={styles.before_icon_abd}
                                          >
                                            $
                                          </Typography>
                                        </>
                                      ),
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    className={styles.update_field_spnss}
                                  >
                                    <i>
                                      <AlertIcon />
                                    </i>
                                    You can not update this field.
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <Box className={styles.second_tab_outers}>
                        <Typography
                          variant="h4"
                          className={`${styles.profile_upload_head} ${styles.gapless}`}
                        >
                          Profile Picture
                        </Typography>
                        <Box className={styles.update_profile_pic_row}>
                          <Box className={styles.update_profile_col_lft}>
                            <Box className={styles.profile_pic_upload_sec}>
                              <Box className={styles.gap_wrapper_emltb}>
                                <Box
                                  className={styles.upload_profile_pic_parent}
                                >
                                  <Box className={styles.file_upload_prof_lf}>
                                    {profileImg !== null ? (
                                      <img
                                        src={
                                          profileImage
                                            ? URL.createObjectURL(profileImage)
                                            : getAbsoluteImageURI(
                                                partnerData?.data?.avatar
                                              )
                                        }
                                        alt=""
                                      />
                                    ) : profileImage === null ? (
                                      <img src={NOprofileImage} alt="" />
                                    ) : (
                                      <img
                                        src={
                                          profileImage
                                            ? URL.createObjectURL(profileImage)
                                            : getAbsoluteImageURI(
                                                partnerData?.data?.avatar
                                              )
                                        }
                                        alt=""
                                      />
                                    )}
                                    {/* {profileImage !== null ? (
                                      <img
                                        src={URL.createObjectURL(profileImage)}
                                        alt=""
                                      />
                                    ) : profileImg === null ? (
                                      <img src={NOprofileImage} alt="" />
                                    ) : (
                                      <img
                                        src={getAbsoluteImageURI(
                                          partnerData?.data?.avatar
                                        )}
                                        alt=""
                                      />
                                    )}
                                    <img
                                      src={
                                        profileImage
                                          ? URL.createObjectURL(profileImage)
                                          : getAbsoluteImageURI(
                                              partnerData?.data?.avatar
                                            )
                                      }
                                      alt=""
                                    /> */}
                                  </Box>

                                  <Box className={styles.file_upload_prof_rght}>
                                    <Box className={styles.file_uploader_btns}>
                                      <Box
                                        className={styles.file_uploader_picture}
                                      >
                                        <Box
                                          className={
                                            styles.file_uploader_picture_in
                                          }
                                        >
                                          {profileImage !== null ? (
                                            <Button onClick={handleSubmit}>
                                              Update Picture
                                            </Button>
                                          ) : (
                                            <Button
                                              onClick={() => handleClick()}
                                            >
                                              Upload Picture
                                            </Button>
                                          )}
                                          <TextField
                                            type="file"
                                            ref={fileInput}
                                            onChange={handleProfileImage}
                                          />
                                        </Box>
                                      </Box>

                                      <Box className={styles.file_remover}>
                                        <Box className={styles.file_remover_in}>
                                          <Button onClick={removeprofileImage}>
                                            Remove It
                                          </Button>
                                        </Box>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>

                          <Box className={styles.update_profile_col_rttt}>
                            <Box className={styles.accountname_pt}>
                              <Box className={styles.heaing_info_label}>
                                <Typography variant="h4">
                                  Account Name
                                  {dis4 ? (
                                    <Link
                                      to=""
                                      className={styles.wdit_spn}
                                      onClick={handelOpen4}
                                    >
                                      {" "}
                                      <EditIcon />{" "}
                                    </Link>
                                  ) : (
                                    <span>
                                      <Link
                                        to=""
                                        onClick={handelClose4}
                                        className={styles.wdit_spn}
                                      >
                                        {" "}
                                        <TabBackIcon />
                                      </Link>
                                      <Link
                                        to=""
                                        className={styles.wdit_spn}
                                        onClick={handelUpdate4}
                                      >
                                        {" "}
                                        <TabSaveIcon />
                                      </Link>
                                    </span>
                                  )}
                                </Typography>
                              </Box>
                              <Box
                                className={`${styles.gap_wrapper_emltb} ${styles.new_gap}`}
                              >
                                <Grid
                                  container
                                  rowSpacing={2.75}
                                  columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                                >
                                  <Grid item xs={12}>
                                    <Grid
                                      container
                                      rowSpacing={2.75}
                                      columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                                    >
                                      <Grid item lg={12} xs={12}>
                                        <Box
                                          className={styles.namedetails_input}
                                        >
                                          <TextField
                                            disabled={dis4}
                                            name="account_name"
                                            onChange={handleFormData}
                                            value={getFormInputValue(
                                              "account_name"
                                            )}
                                          />
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Box>
                          </Box>
                        </Box>

                        <Box className={styles.email_details_inputsec}>
                          <Box className={styles.email_submit_inners}>
                            <Box className={styles.email_submit_col_lf}>
                              <Box
                                className={styles.email_details_inputsec_inner}
                              >
                                <Typography
                                  variant="h4"
                                  className={`${styles.profile_upload_head} ${styles.neww1}`}
                                >
                                  Email Address
                                </Typography>
                                <Box className={styles.gap_wrapper_emltb}>
                                  <Box className={styles.add_user_address}>
                                    <Typography variant="body1">
                                      Your email address is{" "}
                                      <Link
                                        to={`mailto:${getFormInputValue(
                                          "email"
                                        )}`}
                                      >
                                        {getFormInputValue("email")}
                                      </Link>
                                    </Typography>
                                  </Box>
                                  <Box className={styles.add_user_emailchn}>
                                    <Typography variant="caption">
                                      <i>
                                        <AlertIcon />
                                      </i>
                                      Email address cannot be changed.
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>

                            <Box className={styles.email_submit_col_rtt}>
                              <Box
                                className={styles.email_details_inputsec_inner}
                              >
                                <Typography
                                  variant="h4"
                                  className={`${styles.profile_upload_head} ${styles.neww1}`}
                                >
                                  Submission Page
                                </Typography>
                                <Box
                                  className={`${styles.gap_wrapper_emltb} ${styles.new_gap}`}
                                >
                                  <Box className={styles.add_user_address}>
                                    <Typography variant="body1">
                                      Your submission page URL is{" "}
                                      <Link to="mailto:avraam.viralsnare.com">
                                        avraam.viralsnare.com
                                      </Link>
                                    </Typography>
                                  </Box>
                                  <Box className={styles.add_user_emailchn}>
                                    <Typography variant="caption">
                                      <i>
                                        <AlertIcon />
                                      </i>
                                      Submission page cannot be changed.
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>

                          <Box className={styles.email_details_inputsec_inner}>
                            <Typography
                              variant="h4"
                              className={`${styles.profile_upload_head} ${styles.neww}`}
                            >
                              Password
                            </Typography>
                            <Box className={styles.gap_wrapper_emltb}>
                              <Grid
                                container
                                rowSpacing={2.75}
                                columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                                className={styles.row_gap_emtlb}
                              >
                                <Grid item xs={12}>
                                  <Grid
                                    container
                                    rowSpacing={2.75}
                                    columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                                    className={styles.row_gap_emtlb}
                                  >
                                    <Grid item lg={4.04} xs={12}>
                                      <Box className={styles.namedetails_input}>
                                        <Typography
                                          variant="h6"
                                          className={`${styles.heading_label} ${styles.newl_label}`}
                                        >
                                          Current password
                                        </Typography>
                                        <TextField
                                          type="password"
                                          name="old_password"
                                          value={getFormInputValue(
                                            "old_password"
                                          )}
                                          onChange={handleFormData}
                                        />
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                  <Grid
                                    container
                                    rowSpacing={2.75}
                                    columnSpacing={{ xs: 1, sm: 2, md: 5.88 }}
                                    className={styles.row_gap_emtlb}
                                  >
                                    <Grid item lg={4.07} xs={12}>
                                      <Box className={styles.namedetails_input}>
                                        <Typography
                                          variant="h6"
                                          className={`${styles.heading_label} ${styles.newl_label}`}
                                        >
                                          New password
                                        </Typography>
                                        <TextField
                                          type="password"
                                          name="password"
                                          value={getFormInputValue("password")}
                                          onChange={handleFormData}
                                        />
                                      </Box>
                                    </Grid>

                                    <Grid item lg={4.05} xs={12}>
                                      <Box className={styles.namedetails_input}>
                                        <Typography
                                          variant="h6"
                                          className={`${styles.heading_label} ${styles.newl_label}`}
                                        >
                                          Confirm new password
                                        </Typography>
                                        <TextField
                                          type="password"
                                          name="confirm_password"
                                          value={getFormInputValue(
                                            "confirm_password"
                                          )}
                                          onChange={handleFormData}
                                        />
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                  <Box className={styles.submit_password_sec}>
                                    <Button onClick={changePassword}>
                                      Save Password
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </CustomTabPanel>
                  </PerfectScrollbar>
                </Box>
              </Box>

              <Box className={styles.customaccount_wrappers_rt}>
                {loginaccess ? (
                  <Box
                    className={`${styles.tripati_sec_rtt} ${styles.no_back_sec}`}
                  >
                    <Box className={styles.main_imgs}>
                      <img src={tipati_logo} alt="" />
                    </Box>
                    <Typography variant="body1">
                      Your Tipalti account is not set yet.
                    </Typography>
                    <Box className={styles.login_sec_btns}>
                      <Button
                        className={styles.login_btn_ylw}
                        onClick={handleloginsubmit}
                      >
                        <i>
                          <MessageIcons />
                        </i>
                        Request Access
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box className={styles.tripati_sec_rtt}>
                    <Box className={styles.main_imgs}>
                      <img src={tipati_logo} alt="" />
                    </Box>
                    <Typography variant="body1">
                      You are eligible to receive payments.
                    </Typography>
                    <Box className={styles.login_sec_btns}>
                      <Button
                        onClick={handleloginsubmit}
                        className={styles.login_btn_ylw}
                      >
                        <Typography
                          variant="caption"
                          className={styles.login_inner_spns}
                        >
                          <i>
                            <LogIcons />
                          </i>
                          Login
                        </Typography>
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </MemberPartnerDashboardWrapper>
  );
}

export default MemberPartnerAccount;
